import { createAction, props } from "@ngrx/store";
import { Error } from "tslint/lib/error";
import { FirebaseCredential } from "../models/firebase/FirebaseCredential";
import { SMBrand } from "../models/SMBrand";
import { SMBrandOwner } from "../models/SMBrandOwner";

export enum AppActionType {

    ResetState = 'RESET_STATE',

    LoadSemtID = 'Load semt id',
    LoadSemtIDSuccess = 'Load semt id success',
    LoadSemtIDError = 'Load semt id error',

    Login = 'Login to semt',
    LoginSuccess = 'Login success to semt',
    LoginError = 'Login error to semt',

    LoadCurrentUser = 'Load Current User',
    LoadCurrentUserSuccess = 'Load Current User success',
    LoadCurrentUserError = 'Load Current User error',

    LoadCurrentUserData = 'Load Current User data',
    LoadCurrentUserDataSuccess = 'Load Current User data success',
    LoadCurrentUserDataError = 'Load Current User data error',

    LoadCurrentBrandData = 'Load Current Brand data',
    LoadCurrentBrandDataSuccess = 'Load Current Brand data success',
    LoadCurrentBrandDataError = 'Load Current Brand data error',

    LoadTempBrandData = 'Load temp Brand data',
    LoadTempBrandDataSuccess = 'Load temp Brand data success',
    LoadTempBrandDataError = 'Load temp Brand data error',

    LoadAllBrandsData = 'Load all Brand data',
    LoadAllBrandsDataSuccess = 'Load all Brand data success',
    LoadAllBrandsDataError = 'Load all Brand data error',

    CreateBrandOwnerData = 'Create brand owner data',
    CreateBrandOwnerDataSuccess = 'Create brand owner data success',
    CreateBrandOwnerDataError = 'Create brand owner data error',

    CreateBrandOwnerFirebaseAuth = 'Create brand owner firebase auth data',
    CreateBrandOwnerFirebaseAuthSuccess = 'Create brand owner firebase auth data success',
    CreateBrandOwnerFirebaseAuthError = 'Create brand owner firebase auth data error',

    CreateBrandData = 'Create brand data',
    CreateBrandDataSuccess = 'Create brand data success',
    CreateBrandDataError = 'Create brand data error',

    UpdateBrandOwnerData = 'Update brand owner data',
    UpdateBrandOwnerDataSuccess = 'Update brand owner data success',
    UpdateBrandOwnerDataError = 'Update brand owner data error',

    UpdateBrandData = 'Update brand data',
    UpdateBrandDataSuccess = 'Update brand data success',
    UpdateBrandDataError = 'Update brand data error',

    UpdateTempBrandData = 'Update Temp brand data',
    UpdateTempBrandDataSuccess = 'Update Temp brand data success',
    UpdateTempBrandDataError = 'Update brand data error',

    UploadImage = 'upload image data',
    UploadImageSuccess = 'upload image data success',
    UploadImageError = 'upload image data error',

    LoadTempBrandOwnerData = 'Load temp brand owner data',
    LoadTempBrandOwnerDataSuccess = 'Load temp brand owner data success',
    LoadTempBrandOwnerDataError = 'Load temp brand owner data error',
}

export const resetState = createAction(AppActionType.ResetState);

export const loadSemtID = createAction(AppActionType.LoadSemtID);
export const loadSemtIDSuccess = createAction(AppActionType.LoadSemtIDSuccess, props<{ semtID: string }>());
export const loadSemtIDSError = createAction(AppActionType.LoadSemtIDError, props<{ error: Error }>());

export const login = createAction(AppActionType.Login, props<{ username: string, password: string }>());
export const loginSuccess = createAction(AppActionType.LoginSuccess, props<{ credential: FirebaseCredential }>());
export const loginError = createAction(AppActionType.LoginError, props<{ error: Error }>());

export const loadCurrentUser = createAction(AppActionType.LoadCurrentUser);
export const loadCurrentUserSuccess = createAction(AppActionType.LoadCurrentUserSuccess, props<{ user: FirebaseCredential }>());
export const loadCurrentUserError = createAction(AppActionType.LoadCurrentUserError, props<{ error: Error }>());

export const loadCurrentUserData = createAction(AppActionType.LoadCurrentUserData, props<{ id: string }>());
export const loadCurrentUserDataSuccess = createAction(AppActionType.LoadCurrentUserDataSuccess, props<{ userData: SMBrandOwner }>());
export const loadCurrentUserDataError = createAction(AppActionType.LoadCurrentUserDataError, props<{ error: Error }>());

export const loadCurrentBrandData = createAction(AppActionType.LoadCurrentBrandData, props<{ id: string }>());
export const loadCurrentBrandDataSuccess = createAction(AppActionType.LoadCurrentBrandDataSuccess, props<{ brandData: SMBrand }>());
export const loadCurrentBrandDataError = createAction(AppActionType.LoadCurrentBrandDataError, props<{ error: Error }>());

export const loadTempBrandData = createAction(AppActionType.LoadTempBrandData, props<{ id: string }>());
export const loadTempBrandDataSuccess = createAction(AppActionType.LoadTempBrandDataSuccess, props<{ brandData: SMBrand }>());
export const loadTempBrandDataError = createAction(AppActionType.LoadTempBrandDataError, props<{ error: Error }>());

export const loadAllBrandsData = createAction(AppActionType.LoadAllBrandsData);
export const loadAllBrandsDataSuccess = createAction(AppActionType.LoadAllBrandsDataSuccess, props<{ brandsData: SMBrand[] }>());
export const loadAllBrandsDataError = createAction(AppActionType.LoadAllBrandsDataError, props<{ error: Error }>());

export const createBrandOwnerData = createAction(AppActionType.CreateBrandOwnerData, props<{ brandOwner:SMBrandOwner }>());
export const createBrandOwnerDataSuccess = createAction(AppActionType.CreateBrandOwnerDataSuccess, props<{ brandOwner: SMBrandOwner }>());
export const createBrandOwnerDataError = createAction(AppActionType.CreateBrandOwnerDataError, props<{ error: Error }>());

export const createBrandOwnerFirebaseAuth = createAction(AppActionType.CreateBrandOwnerFirebaseAuth, props<{ brandOwner:string, password: string }>());
export const createBrandOwnerFirebaseAuthSuccess = createAction(AppActionType.CreateBrandOwnerFirebaseAuthSuccess, props<{ cred: FirebaseCredential }>());
export const createBrandOwnerFirebaseAuthError = createAction(AppActionType.CreateBrandOwnerFirebaseAuthError, props<{ error: Error }>());

export const createBrandData = createAction(AppActionType.CreateBrandData, props<{ brand:SMBrand }>());
export const createBrandDataSuccess = createAction(AppActionType.CreateBrandDataSuccess, props<{ brand: SMBrand }>());
export const createBrandDataError = createAction(AppActionType.CreateBrandDataError, props<{ error: Error }>());

export const updateBrandOwnerData = createAction(AppActionType.UpdateBrandOwnerData, props<{ brandOwner:SMBrandOwner }>());
export const updateBrandOwnerDataSuccess = createAction(AppActionType.UpdateBrandOwnerDataSuccess, props<{ brandOwner: SMBrandOwner }>());
export const updateBrandOwnerDataError = createAction(AppActionType.UpdateBrandOwnerDataError, props<{ error: Error }>());

export const updateBrandData = createAction(AppActionType.UpdateBrandData, props<{ brand:SMBrand }>());
export const updateBrandDataSuccess = createAction(AppActionType.UpdateBrandDataSuccess);
export const updateBrandDataError = createAction(AppActionType.UpdateBrandDataError, props<{ error: Error }>());

export const uploadImage = createAction(AppActionType.UploadImage, props<{ file: any }>());
export const uploadImageSuccess = createAction(AppActionType.UploadImageSuccess, props<{ filePath: string }>());
export const uploadImageError = createAction(AppActionType.UploadImageError, props<{ error: Error }>());

export const loadTempBrandOwnerData = createAction(AppActionType.LoadTempBrandOwnerData, props<{ id: string }>());
export const loadTempBrandOwnerDataSuccess = createAction(AppActionType.LoadTempBrandOwnerDataSuccess, props<{ brandOwnerData: SMBrandOwner }>());
export const loadTempBrandOwnerDataError = createAction(AppActionType.LoadTempBrandOwnerDataError, props<{ error: Error }>());

export const updateTempBrandData = createAction(AppActionType.UpdateTempBrandData, props<{ brand:SMBrand }>());
export const updateTempBrandDataSuccess = createAction(AppActionType.UpdateTempBrandDataSuccess);
export const updateTempBrandDataError = createAction(AppActionType.UpdateTempBrandDataError, props<{ error: Error }>());



